cb.define([], function () {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };


    var PM_pmc_postactivity_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var unit = cb.rest.AppContext.user.currencyName || "元";

            viewmodel.get('postArea').on("afterCellValueChange", function (data) {
                if (data.cellName == "cRegion") {
                    let mergerName = data.value.mergerName ? data.value.mergerName.split(',') : [];
                    let cCountry = mergerName[0] || null;
                    let cProvince = mergerName[1] || null;
                    let cCity = mergerName[2] || null;
                    let cArea = mergerName[3] || null;
                    let pActivityRange = viewmodel.get('pActivityRange').getValue();
                    viewmodel.get('postArea').setCellValue(data.rowIndex, 'iPostAreaType', pActivityRange);
                    viewmodel.get('postArea').setCellValue(data.rowIndex, 'cCountry', cCountry);
                    viewmodel.get('postArea').setCellValue(data.rowIndex, 'cProvince', cProvince);
                    viewmodel.get('postArea').setCellValue(data.rowIndex, 'cCity', cCity);
                    viewmodel.get('postArea').setCellValue(data.rowIndex, 'cArea', cArea);
                }
            });

            let mode = viewmodel.getParams().mode;
            viewmodel.get('postArea').getEditRowModel().get('cRegion').setState('changeOnSelect', true);
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');

            // viewmodel.get('position') && viewmodel.get('position').setState('bIsNull', true);

            viewmodel.on('afterEdit', function (data) {
                if (this.get('pActivityRange').getValue() == 0) {
                    viewmodel.get('postArea').setVisible(true);
                    viewmodel.get('btnAddRow').setVisible(false);

                } else if (this.get('pActivityRange').getValue() == 1) {
                    viewmodel.get('postArea').setVisible(false);
                    if (mode == 'browse') {
                    } else if (mode == 'edit' || mode == 'add') {
                        viewmodel.get('btnAddRow').setVisible(true);
                    }
                } else {
                    viewmodel.get('postArea').setVisible(false);
                    if (mode == 'browse') {
                    } else if (mode == 'edit' || mode == 'add') {
                        viewmodel.get('btnAddRow').setVisible(true);
                    }
                }
            })
            viewmodel.on('afterLoadData', function (data) {
                let mode = viewmodel.getParams().mode;
                if(viewmodel.get("memberLevelAll").getValue()==0){
                  viewmodel.get("postActivityMember").setVisible(true);
                } else {
                  viewmodel.get('postActivityMember').setVisible(false);
                }

                viewmodel.get("pPostPrice").setState("after", unit);

                /**InputNumber不为负数**/
                this.get('pPostPrice').setState('min', 0);
                this.get('iPostPieces').setState('min', 0);


                if (this.get('pActivityRange').getValue() == 0) {
                    viewmodel.get('postArea').setVisible(true);
                    viewmodel.get('btnAddRow').setVisible(false);

                } else if (this.get('pActivityRange').getValue() == 1) {
                    viewmodel.get('postArea').setVisible(false);
                    if (mode == 'browse') {
                    } else if (mode == 'edit' || mode == 'add') {
                        viewmodel.get('btnAddRow').setVisible(true);
                    }
                } else {
                    viewmodel.get('postArea').setVisible(false);
                    if (mode == 'browse') {
                    } else if (mode == 'edit' || mode == 'add') {
                        viewmodel.get('btnAddRow').setVisible(true);
                    }
                }

            });

          //买家范围控制事件
          viewmodel.get('memberLevelAll').on('afterValueChange', function (data) {
            if (data.value.value === '0') {
              viewmodel.get("postActivityMember").setVisible(true);
            } else {
              viewmodel.get('postActivityMember').setVisible(false);
            }
          });
            viewmodel.get('pActivityRange').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    viewmodel.get('postArea').setVisible(true);
                    viewmodel.get('btnAddRow').setVisible(false);
                } else {
                    let nums = viewmodel.get('postArea').getRowsCount();
                    for (let i = nums - 1; i >= 0; i--) {
                        viewmodel.get('postArea').deleteRows(i);
                    }
                    viewmodel.get('postArea').setVisible(false);
                    viewmodel.get('btnAddRow').setVisible(true);
                }
            })

            viewmodel.on('beforeSave', function (data) {
                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);

                if (viewmodel.get('pActivityRange').getValue() == 1) {
                    if (viewmodel.get('postArea').getRows() == '') {
                        cb.utils.alert('请选择不包邮地区', 'warning');
                        return false;
                    } else {
                        for (var i = 0; i < viewmodel.get('postArea').getRows().length; i++) {
                            if (viewmodel.get('postArea').getRows()[i].cRegion === undefined) {
                                cb.utils.alert('请选择不包邮地区', 'warning');
                                return false;
                            }
                        }
                    }
                } else if (viewmodel.get('pActivityRange').getValue() == 2) {
                    if (viewmodel.get('postArea').getRows() == '') {
                        cb.utils.alert('请选择包邮地区', 'warning');
                        return false;
                    } else {
                        for (var i = 0; i < viewmodel.get('postArea').getRows().length; i++) {
                            if (viewmodel.get('postArea').getRows()[i].cRegion === undefined) {
                                cb.utils.alert('请选择包邮地区', 'warning');
                                return false;
                            }
                        }
                    }

                }
                // if(mode == 'add'){
                // 	if(viewmodel.get('pStartDate').getValue() <= nowDates){
                // 		cb.utils.alert('开始时间大于当前时间', 'warning');
                // 		return false;
                // 	}
                // }

                if (viewmodel.get('pStartDate').getValue() >= viewmodel.get('pEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }
              if (this.get('memberLevelAll').getValue() == '0' && this.get('postActivityMember').getShowValue() == '') {
                cb.utils.alert('指定会员不可为空', 'warning');
                return false;
              } else if (this.get('memberLevelAll').getValue() != '0') {
                obj.postActivityMember = [];
              }

                data.data.data = JSON.stringify(obj);

            })
        }
    };
    try {
        module.exports = PM_pmc_postactivity_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_postactivity_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_postactivity_VM.Extend.js